module.exports = __webpack_public_path__ + "static/img/img_ship.5ac307a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productStage/img_ship.png
// module id = jOWS
// module chunks = 44